<p-toast></p-toast>
<div
  class="container"
  *ngIf="searched && data && data.length > 0; else noResultsFound"
>
  <div class="main-content" *ngFor="let item of data; let i = index">
    <div
      class="card"
      [ngClass]="{ expanded: expandedCards[i], collapsed: !expandedCards[i] }"
    >
      <div *ngIf="i % 1 === 0" class="route-label-container">
        <div class="line"></div>
        <div class="route-label">
          Tech Routes
          {{
            currentPage_technical === 1
              ? i + 1
              : (currentPage_technical - 1) * (currentRow_technical || 15) +
                i +
                1
          }}
        </div>

        <!-- Pass both recordId and routeIndex to splitDownload -->
        <button
          *ngIf="privilege_json?.SplitDownload"
          (click)="splitDownload(item._id, i)"
          style="
            background: linear-gradient(145.5deg, #388e3c, #235e5e 99.58%);
            color: #ffed8d;
            border: none;
            padding: 5px 15px;
            border-radius: 12px;
            cursor: pointer;
            font-weight: 700;
            font-size: 14px;
            display: inline-flex;
            align-items: center;
            gap: 8px;
            box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
            white-space: nowrap;
            transition: all 0.3s ease;
            margin-left: 5px;
          "
          onmouseover="this.style.opacity='0.9'"
          onmouseout="this.style.opacity='1'"
        >
          <i class="pi pi-download" style="font-size: 14px"></i>
          Download
        </button>
        <div class="line"></div>
      </div>
      <section class="product-info" id="productinfo">
        <h4
          style="
            font-weight: 800;
            font-size: 20px;
            color: #388e3c;

            margin-bottom: 20px;
            text-align: left;
            background: linear-gradient(to right, #388e3c, #006400);
            -webkit-background-clip: text;
            color: transparent;
            text-shadow: 2px 2px 5px rgba(0, 0, 0, 0.1),
              -2px -2px 5px rgba(0, 0, 0, 0.1);
            letter-spacing: 1px;
            transition: color 0.3s ease, text-shadow 0.3s ease;
          "
        >
          {{ item.activeIngredient || "-" }}
          <button
            class="copy-btn"
            *ngIf="item.activeIngredient"
            (click)="copyToClipboard(item.activeIngredient)"
            pTooltip="Copy to clipboard"
            tooltipPosition="top"
          >
            <i class="pi pi-copy"></i>
          </button>
        </h4>
        <!-- Chemical Structure Image -->
        <div class="product-container2">
          <!-- Left Side: Chemical Structure -->
          <div class="chemical-structure2" *ngIf="item.routeOfSynthesis">
            <!-- <h2>Chemical Structure</h2> -->
            <div class="image-container2">
              <img
                class="inventor-logo"
                *ngIf="displayMap['routeOfSynthesis'] && item.routeOfSynthesis"
                [src]="
                  'https://www.chemrobotics.com/agropat/images/route_of_synthesis/' +
                  item.routeOfSynthesis
                "
                alt="Inventor Logo"
              />
            </div>
            <button class="view-btn2" (click)="openGalleria(item)">
              <i class="pi pi-search"></i>
            </button>
          </div>

          <!-- Right Side: Product Information -->
          <div class="product-info-container2">
            <div class="product-info2" *ngIf="displayMap['gbrn'] && item.gbrn">
              <h6>
                GBRN
                <button
                  class="copy-btn2"
                  (click)="copyToClipboard(item.gbrn)"
                  pTooltip="Copy to clipboard"
                  tooltipPosition="top"
                >
                  <i class="pi pi-copy"></i>
                </button>
              </h6>

              {{ item.gbrn }}
            </div>
            <div class="product-info2" *ngIf="displayMap['trrn'] && item.trrn">
              <h6>
                TRRN
                <button
                  class="copy-btn2"
                  (click)="copyToClipboard(item.trrn)"
                  pTooltip="Copy to clipboard"
                  tooltipPosition="top"
                >
                  <i class="pi pi-copy"></i>
                </button>
              </h6>

              <p>
                {{ item.trrn || "-" }}
              </p>
            </div>
            <div
              class="product-info2"
              *ngIf="displayMap['activeIngredient'] && item.activeIngredient"
            >
              <h6>
                ACTIVE INGREDIENT
                <button
                  class="copy-btn2"
                  *ngIf="item.activeIngredient"
                  (click)="copyToClipboard(item.activeIngredient)"
                  pTooltip="Copy to clipboard"
                  tooltipPosition="top"
                >
                  <i class="pi pi-copy"></i>
                </button>
              </h6>
              <p>
                {{ item.activeIngredient || "-" }}
              </p>
            </div>
            <div
              class="product-info2"
              *ngIf="
                displayMap['activeIngredientCasRn'] &&
                item.activeIngredientCasRn
              "
            >
              <h6>
                CAS RN
                <button
                  class="copy-btn2"
                  *ngIf="item.activeIngredientCasRn"
                  (click)="copyToClipboard(item.activeIngredientCasRn)"
                  pTooltip="Copy to clipboard"
                  tooltipPosition="top"
                >
                  <i class="pi pi-copy"></i>
                </button>
              </h6>
              <p>
                {{ item.activeIngredientCasRn || "-" }}
              </p>
            </div>
            <div
              class="product-info2"
              *ngIf="
                displayMap['fieldOfApplication'] && item.fieldOfApplication
              "
            >
              <h6>
                FIELD OF APPLICATION
                <button
                  class="copy-btn2"
                  *ngIf="item.fieldOfApplication"
                  (click)="copyToClipboard(item.fieldOfApplication)"
                  pTooltip="Copy to clipboard"
                  tooltipPosition="top"
                >
                  <i class="pi pi-copy"></i>
                </button>
              </h6>

              <p>
                {{ item.fieldOfApplication || "-" }}
              </p>
            </div>
            <div
              class="product-info2"
              *ngIf="displayMap['companyName'] && item.companyName"
            >
              <h6>
                COMPANY NAME
                <button
                  class="copy-btn2"
                  *ngIf="item.companyName"
                  (click)="copyToClipboard(item.companyName)"
                  pTooltip="Copy to clipboard"
                  tooltipPosition="top"
                >
                  <i class="pi pi-copy"></i>
                </button>
              </h6>

              <p>{{ item.companyName || "-" }}</p>
              <div class="logos-images">
                <img
                  style="width: 100px"
                  *ngIf="
                    displayMap['companyLogo'] && item.companyLogo;
                    else placeholder
                  "
                  [src]="
                    'https://www.chemrobotics.com/agropat/images/innovators_logo/' +
                    item.companyLogo
                  "
                  alt="Inventor Logo"
                  class="inventor-logo"
                  (error)="onImageError($event)"
                />
                <ng-template #placeholder>
                  <span style="width: 300px; display: inline-block"
                    >INVENTOR LOGO</span
                  >
                </ng-template>
              </div>
            </div>
          </div>
        </div>

        <!-- Bootstrap Modal for Full Image View -->
        <p-galleria
          [value]="galleriaImages"
          [(visible)]="displayGalleria"
          [containerStyle]="{ 'max-width': '100%' }"
          [numVisible]="1"
          [circular]="true"
          [fullScreen]="true"
          [showItemNavigators]="false"
          [showThumbnails]="false"
        >
          <ng-template pTemplate="item" let-item>
            <!-- Modal Background (Click to Close) -->
            <div class="modal-overlay" (click)="closeGalleria($event)">
              <div class="image-wrapper" (click)="$event.stopPropagation()">
                <!-- Zoom Controls Positioned at the Top Right -->
                <div class="zoom-controls">
                  <button (click)="zoomIn($event)" title="Zoom In">
                    <i class="pi pi-search-plus"></i>
                  </button>
                  <button (click)="zoomOut($event)" title="Zoom Out">
                    <i class="pi pi-search-minus"></i>
                  </button>
                  <button class="close-button" (click)="closeGalleria($event)">
                    ×
                  </button>
                </div>

                <!-- Scrollable Image Container -->
                <div class="zoom-container">
                  <img
                    [src]="item.itemImageSrc"
                    [style.transform]="'scale(' + zoomLevel + ')'"
                    class="zoomable-image"
                  />
                </div>
              </div>
            </div>
          </ng-template>
        </p-galleria>

        <div class="logos" id="contentToExport3">
          <!-- <h3 class="logos-title">Innovators' Logos</h3> -->
          <!-- Title remains above images -->
          <!-- inventorLogo -->

          <!-- <div class="result-header">
      <h6 style="margin-top: 8px">
        {{ item.companyLogo || "-" }}
      </h6>
    </div> -->
        </div>

        <div class="product-detail" id="contentToExport1">
          <div class="grid grid-cols-3" style="margin-top: -20px">
            <div
              class="product-info2"
              *ngIf="displayMap['companyType'] && item.companyType"
            >
              <h6>
                COMPANY TYPE
                <button
                  class="copy-btn2"
                  (click)="copyToClipboard(item.companyType)"
                >
                  <i class="pi pi-copy"></i>
                </button>
              </h6>
              <p>{{ item.companyType || "-" }}</p>
            </div>
            <div
              class="product-info2"
              *ngIf="displayMap['patentType'] && item.patentType"
            >
              <h6>
                PATENT TYPE
                <button
                  class="copy-btn2"
                  (click)="copyToClipboard(item.patentType)"
                >
                  <i class="pi pi-copy"></i>
                </button>
              </h6>
              <p>{{ item.patentType || "-" }}</p>
            </div>
            <div
              class="product-info2"
              *ngIf="displayMap['routeType'] && item.routeType"
            >
              <h6>
                ROUTE TYPE
                <button
                  class="copy-btn"
                  *ngIf="item.routeType"
                  (click)="copyToClipboard(item.routeType)"
                  pTooltip="Copy to clipboard"
                  tooltipPosition="top"
                >
                  <i class="pi pi-copy"></i>
                </button>
              </h6>
              <p>
                {{ item.routeType || "-" }}
              </p>
            </div>
            <div
              class="product-info2"
              *ngIf="displayMap['typesOfRoute'] && item.typesOfRoute"
            >
              <h6>
                TYPES OF ROUTE
                <button
                  class="copy-btn"
                  *ngIf="item.typesOfRoute"
                  (click)="copyToClipboard(item.typesOfRoute)"
                  pTooltip="Copy to clipboard"
                  tooltipPosition="top"
                >
                  <i class="pi pi-copy"></i>
                </button>
              </h6>
              <p>
                {{ item.typesOfRoute || "-" }}
              </p>
            </div>
            <div
              class="product-info2"
              *ngIf="displayMap['countryOfCompany'] && item.countryOfCompany"
            >
              <h6>
                COUNTRY OF COMPANY
                <button
                  class="copy-btn2"
                  (click)="copyToClipboard(item.countryOfCompany)"
                >
                  <i class="pi pi-copy"></i>
                </button>
              </h6>
              <p>{{ item.countryOfCompany || "-" }}</p>
            </div>
            <div
              class="product-info2"
              *ngIf="displayMap['updationDate'] && item.updationDate"
            >
              <h6>updation date</h6>

              {{
                item.updationDate
                  ? (item.updationDate | date : "yyyy-MM-dd")
                  : "-"
              }}
              <button
                class="copy-btn"
                *ngIf="item.updationDate"
                (click)="copyToClipboardFormattedDate(item.updationDate)"
                pTooltip="Copy to clipboard"
                tooltipPosition="top"
              >
                <i class="pi pi-copy"></i>
              </button>
            </div>
            <div
              class="product-info2"
              *ngIf="
                displayMap['smiliesOfReactants'] && item.smiliesOfReactants
              "
            >
              <h6>
                SMILIES OF REACTANTS
                <button
                  class="copy-btn2"
                  (click)="copyToClipboard(item.smiliesOfReactants)"
                >
                  <i class="pi pi-copy"></i>
                </button>
              </h6>
              <p>{{ item.smiliesOfReactants || "-" }}</p>
            </div>

            <div
              class="product-info2"
              *ngIf="displayMap['patentType'] && item.patentType"
            >
              <h6>
                PATENT OR NON-PATENT TYPE
                <button
                  class="copy-btn2"
                  (click)="copyToClipboard(item.patentType)"
                >
                  <i class="pi pi-copy"></i>
                </button>
              </h6>
              <p>{{ item.patentType || "-" }}</p>
            </div>

            <div
              class="product-info2"
              *ngIf="
                displayMap['digitalObjectIdentifier'] &&
                item.digitalObjectIdentifier
              "
            >
              <h6>
                DIGITAL OBJECT IDENTIFIER (DOI)
                <button
                  class="copy-btn2"
                  (click)="copyToClipboard(item.digitalObjectIdentifier)"
                >
                  <i class="pi pi-copy"></i>
                </button>
              </h6>
              <p>{{ item.digitalObjectIdentifier || "-" }}</p>
            </div>
            <div
              class="product-info2"
              *ngIf="displayMap['monthlyBatches'] && item.monthlyBatches"
            >
              <h6>
                MONTHLY BATCHES
                <button
                  class="copy-btn"
                  *ngIf="item.monthlyBatches"
                  (click)="copyToClipboard(item.monthlyBatches)"
                  pTooltip="Copy to clipboard"
                  tooltipPosition="top"
                >
                  <i class="pi pi-copy"></i>
                </button>
              </h6>

              <p>
                {{ item.monthlyBatches || "-" }}
              </p>
            </div>
            <div
              class="product-info2"
              *ngIf="
                displayMap['uniformResourceLocator'] &&
                item.uniformResourceLocator
              "
            >
              <h6>PATENT OR NON-PATENT URL</h6>
              <p>
                <ng-container
                  *ngFor="let link of item.uniformResourceLocator.split(';')"
                >
                  <button
                    *ngIf="link.trim()"
                    class="visit-link-btn"
                    (click)="openLink(link.trim())"
                  >
                    Visit Link
                  </button>
                </ng-container>
              </p>
            </div>

            <div
              class="product-info2"
              *ngIf="displayMap['technicalField'] && item.technicalField"
            >
              <h6>
                TECHNICAL FIELD (S)
                <button
                  class="copy-btn2"
                  *ngIf="item.technicalField"
                  (click)="copyToClipboard(item.technicalField)"
                  pTooltip="Copy to clipboard"
                  tooltipPosition="top"
                >
                  <i class="pi pi-copy"></i>
                </button>
              </h6>
              <p>
                {{ item.technicalField || "-" }}
              </p>
            </div>

            <div
              class="product-info2"
              *ngIf="displayMap['ip_legalStatus'] && item.ip_legalStatus"
            >
              <h6>
                IP LEGAL STATUS
                <button
                  class="copy-btn2"
                  *ngIf="item.ip_legalStatus"
                  (click)="copyToClipboard(item.ip_legalStatus)"
                  pTooltip="Copy to clipboard"
                  tooltipPosition="top"
                >
                  <i class="pi pi-copy"></i>
                </button>
              </h6>
              <p>
                {{ item.ip_legalStatus || "-" }}
              </p>
            </div>
            <div
              class="product-info"
              *ngIf="
                displayMap['downloadableDocs'] && item.downloadableDocs && false
              "
            >
              <h6>DOWNLOADABLE DOCS</h6>
              <p>
                <ng-container
                  *ngFor="let link of item.downloadableDocs.split(';')"
                >
                  <a
                    *ngIf="link.trim()"
                    style="
                      background: linear-gradient(
                        145.5deg,
                        #388e3c,
                        #235e5e 99.58%
                      ) !important ;
                      transition: all 0.3s ease;
                    "
                    [href]="
                      'https://chemrobotics.com/agropat/pdf/gsda/docs/' +
                      link.trim()
                    "
                    target="_blank"
                  >
                    {{ link.trim() }}
                  </a>
                </ng-container>
              </p>
            </div>

            <div
              class="product-info2"
              *ngIf="displayMap['applications'] && item.applications"
            >
              <h6>
                APPLICATIONS
                <button
                  class="copy-btn2"
                  *ngIf="item.applications"
                  (click)="copyToClipboard(item.applications)"
                  pTooltip="Copy to clipboard"
                  tooltipPosition="top"
                >
                  <i class="pi pi-copy"></i>
                </button>
              </h6>
              <p>
                {{ item.applications || "-" }}
              </p>
            </div>

            <div
              class="product-info2"
              *ngIf="
                displayMap['intermediateReactantsCasRn'] &&
                item.intermediateReactantsCasRn
              "
            >
              <h6>
                INTERMEDIATE REACTANTS CAS RN
                <button
                  class="copy-btn2"
                  *ngIf="item.intermediateReactantsCasRn"
                  (click)="copyToClipboard(item.intermediateReactantsCasRn)"
                  pTooltip="Copy to clipboard"
                  tooltipPosition="top"
                >
                  <i class="pi pi-copy"></i>
                </button>
              </h6>
              <p>
                {{ item.intermediateReactantsCasRn || "-" }}
              </p>
            </div>
            <!-- <div class="product-info" *ngIf="item.patentLink">
              <h6>
                PATENT LINK
                <button
                  class="copy-btn"
                  *ngIf="item.patentLink"
                  (click)="copyToClipboard(item.patentLink)"
                  pTooltip="Copy to clipboard"
                  tooltipPosition="top"
                >
                  <i class="pi pi-copy"></i>
                </button>
              </h6>
              <p>
                {{ item.patentLink || "-" }}
              </p>
            </div> -->
            <div
              class="product-info2"
              *ngIf="
                displayMap['presentInventionPatentDisclosure'] &&
                item.presentInventionPatentDisclosure
              "
            >
              <h6>
                PRESENT INVENTION / PATENT DISCLOSURE ABOUT PRIOR ARTS
                <button
                  class="copy-btn2"
                  *ngIf="item.presentInventionPatentDisclosure"
                  (click)="
                    copyToClipboard(item.presentInventionPatentDisclosure)
                  "
                  pTooltip="Copy to clipboard"
                  tooltipPosition="top"
                >
                  <i class="pi pi-copy"></i>
                </button>
              </h6>
              <p>
                {{ item.presentInventionPatentDisclosure || "-" }}
              </p>
            </div>
            <div
              class="product-info2"
              *ngIf="displayMap['patentType'] && item.priorityDate"
            >
              <h6>
                PRIORITY DATE
                <button
                  class="copy-btn2"
                  *ngIf="item.priorityDate"
                  (click)="copyToClipboardFormattedDate(item.priorityDate)"
                  pTooltip="Copy to clipboard"
                  tooltipPosition="top"
                >
                  <i class="pi pi-copy"></i>
                </button>
              </h6>
              <p>
                {{ item.priorityDate ? (item.priorityDate | date : "yyyy-MM-dd") : "-" }}
              </p>
            </div>
            <div class="product-info2" *ngIf="displayMap['cprn'] && item.cprn">
              <h6>
                CPRN
                <button
                  class="copy-btn2"
                  *ngIf="item.cprn"
                  (click)="copyToClipboard(item.cprn)"
                  pTooltip="Copy to clipboard"
                  tooltipPosition="top"
                >
                  <i class="pi pi-copy"></i>
                </button>
              </h6>
              <p>
                {{ item.cprn || "-" }}
              </p>
            </div>
            <div
              class="product-info2"
              *ngIf="displayMap['applicationDate'] && item.applicationDate"
            >
              <h6>
                APPLICATION DATE
                <button
                  class="copy-btn2"
                  *ngIf="item.applicationDate"
                  (click)="copyToClipboardFormattedDate(item.applicationDate)"
                  pTooltip="Copy to clipboard"
                  tooltipPosition="top"
                >
                  <i class="pi pi-copy"></i>
                </button>
              </h6>
              <p>
                {{ item.applicationDate ? (item.applicationDate | date : "yyyy-MM-dd") : "-" }}
              </p>
            </div>
            <div
              class="product-info2"
              *ngIf="
                displayMap['applicationsInAcrossIndustry'] &&
                item.applicationsInAcrossIndustry
              "
            >
              <h6>
                APPLICATIONS IN ACROSS INDUSTRY
                <button
                  class="copy-btn2"
                  *ngIf="item.applicationsInAcrossIndustry"
                  (click)="copyToClipboard(item.applicationsInAcrossIndustry)"
                  pTooltip="Copy to clipboard"
                  tooltipPosition="top"
                >
                  <i class="pi pi-copy"></i>
                </button>
              </h6>
              <p>
                {{ item.applicationsInAcrossIndustry || "-" }}
              </p>
            </div>
            <div
              class="product-info2"
              *ngIf="
                displayMap['manufacturerSupplier'] && item.manufacturerSupplier
              "
            >
              <h6>
                MANUFACTURER SUPPLIER
                <button
                  class="copy-btn2"
                  *ngIf="item.manufacturerSupplier"
                  (click)="copyToClipboard(item.manufacturerSupplier)"
                  pTooltip="Copy to clipboard"
                  tooltipPosition="top"
                >
                  <i class="pi pi-copy"></i>
                </button>
              </h6>
              <p>
                {{ item.manufacturerSupplier || "-" }}
              </p>
            </div>
            <div
              class="product-info2"
              *ngIf="displayMap['inhouseLabel'] && item.inhouseLabel"
            >
              <h6>
                INHOUSE LABEL
                <button
                  class="copy-btn2"
                  *ngIf="item.inhouseLabel"
                  (click)="copyToClipboard(item.inhouseLabel)"
                  pTooltip="Copy to clipboard"
                  tooltipPosition="top"
                >
                  <i class="pi pi-copy"></i>
                </button>
              </h6>
              <p>
                {{ item.inhouseLabel || "-" }}
              </p>
            </div>
          </div>
        </div>
        <br />

        <!-- Additional Product Details -->
        <div class="product-additional-details">
          <div class="grid grid-cols-2 gap-2" style="margin-top: -15px">
            <div
              class="product-info"
              *ngIf="displayMap['patentLink'] && item.patentLink"
            >
              <!-- <h6>GOOGLE PATENT HYPERLINK OF PATENT (PATENT LANDSCAPE)</h6> -->

              <!-- Image Below Heading -->
              <img
                src="../../../../assets/img/GooglePatents.png"
                alt="Patent Icon"
                class="patent-image"
                style="width: 150px; height: 60px"
              />

              <p>
                <ng-container *ngFor="let link of item.patentLink.split(';')">
                  <a
                    *ngIf="link.trim()"
                    [href]="'https://patents.google.com/patent/' + link.trim()"
                    target="_blank"
                  >
                    {{ link.trim() }}
                  </a>
                </ng-container>
              </p>
            </div>

            <div
              class="product-info"
              *ngIf="
                displayMap['uniformResourceLocator'] &&
                item.uniformResourceLocator
              "
            >
              <!-- <h6>ESPACE.NET PATENT HYPERLINK OF PATENT (PATENT LANDSCAPE)</h6> -->
              <img
                src="../../../../assets/img/espace-logo.png"
                alt="Patent Icon"
                class="patent-image"
                style="width: 150px; height: 60px; margin-left: 6px"
              />
              <p>
                <ng-container *ngFor="let link of item.patentLink.split(';')">
                  <a
                    *ngIf="link.trim()"
                    style="
                      background: #be0f04 !important ;
                      transition: all 0.3s ease;
                    "
                    [href]="
                      'https://worldwide.espacenet.com/patent/search/family/' +
                      link.trim() +
                      '/publication/' +
                      link.trim() +
                      'A1?q=' +
                      link.trim()
                    "
                    target="_blank"
                  >
                    {{ link.trim() }}
                  </a>
                </ng-container>
              </p>
            </div>
          </div>

          <!-- <div
            class="section-wrapper"
            id="dataAvailablity"
            *ngIf="dataAvailablity.length > 0"
            let
            i="index1"
          >
            <hr class="section-divider" />
            <h2 class="section-title">Data Availability</h2>

            <a
              *ngFor="let data of dataAvailablity"
              class=""
              [href]="
                'https://www.chemrobotics.com/agropat/pdf/gsda/docs/' +
                data.documents
              "
              target="_blank"
            >
              <button
                class="btn btn-success m-1"
                style="
                  background: linear-gradient(
                    145.5deg,
                    #388e3c,
                    #235e5e 99.58%
                  );
                  color: rgb(255 237 141);
                  gap: 10px;
                "
              >
                {{ data.nameOfDocuments }}
              </button>
            </a>
          </div> -->

          <!-- First Section Wrapper -->
          <div
            class="section-wrapper"
            id="description"
            *ngIf="displayMap['description'] && item.description"
          >
            <hr class="section-divider" />
            <h2 class="section-title">
              description:
              <button
                class="copy-btn"
                *ngIf="item.description"
                (click)="copyToClipboard(item.description)"
                pTooltip="Copy to clipboard"
                tooltipPosition="top"
                style="color: #ffe16a"
              >
                <i class="pi pi-copy"></i>
              </button>
            </h2>
            <p>
              {{ item.description }}
            </p>
            <!-- <p [innerHTML]="transformNewLines(item?.description || '-')"></p> -->
          </div>

          <div
            class="section-wrapper"
            id="description"
            *ngIf="displayMap['reactantsCasRn'] && item.reactantsCasRn"
          >
            <hr class="section-divider" />
            <h2 class="section-title">
              REACTANTS CAS RN
              <button
                class="copy-btn"
                *ngIf="item.reactantsCasRn"
                (click)="copyToClipboard(item.reactantsCasRn)"
                pTooltip="Copy to clipboard"
                tooltipPosition="top"
                style="color: #ffe16a"
              >
                <i class="pi pi-copy"></i>
              </button>
            </h2>
            <p>
              {{ item.reactantsCasRn }}
            </p>
            <!-- <p [innerHTML]="transformNewLines(item?.description || '-')"></p> -->
          </div>
          <div
            class="section-wrapper"
            id="description"
            *ngIf="displayMap['solventAndReagents'] && item.solventAndReagents"
          >
            <hr class="section-divider" />
            <h2 class="section-title">
              SOLVENT & REAGENTS
              <button
                class="copy-btn"
                *ngIf="item.solventAndReagents"
                (click)="copyToClipboard(item.solventAndReagents)"
                pTooltip="Copy to clipboard"
                tooltipPosition="top"
                style="color: #ffe16a"
              >
                <i class="pi pi-copy"></i>
              </button>
            </h2>
            <p>
              {{ item.solventAndReagents }}
            </p>
            <!-- <p [innerHTML]="transformNewLines(item?.description || '-')"></p> -->
          </div>

          <div
            class="section-wrapper"
            id="description"
            *ngIf="
              displayMap['patentOrNonPatentReferences'] &&
              item.patentOrNonPatentReferences
            "
          >
            <hr class="section-divider" />
            <h2 class="section-title">
              PATENT / NON-PATENT REFERENCES
              <button
                class="copy-btn"
                *ngIf="item.patentOrNonPatentReferences"
                (click)="copyToClipboard(item.patentOrNonPatentReferences)"
                pTooltip="Copy to clipboard"
                tooltipPosition="top"
                style="color: #ffe16a"
              >
                <i class="pi pi-copy"></i>
              </button>
            </h2>
            <p>
              {{ item.patentOrNonPatentReferences }}
            </p>
            <!-- <p [innerHTML]="transformNewLines(item?.description || '-')"></p> -->
          </div>

          <div
            class="section-wrapper"
            id="description"
            *ngIf="displayMap['notes'] && item.notes"
          >
            <hr class="section-divider" />
            <h2 class="section-title">
              NOTES
              <button
                class="copy-btn"
                *ngIf="item.notes"
                (click)="copyToClipboard(item.notes)"
                pTooltip="Copy to clipboard"
                tooltipPosition="top"
                style="color: #ffe16a"
              >
                <i class="pi pi-copy"></i>
              </button>
            </h2>
            <p>
              {{ item.notes }}
            </p>
            <!-- <p [innerHTML]="transformNewLines(item?.description || '-')"></p> -->
          </div>

          <div
            class="section-wrapper"
            id="description"
            *ngIf="displayMap['remarks'] && item.remarks"
          >
            <hr class="section-divider" />
            <h2 class="section-title">
              REMARKS
              <button
                class="copy-btn"
                *ngIf="item.remarks"
                (click)="copyToClipboard(item.remarks)"
                pTooltip="Copy to clipboard"
                tooltipPosition="top"
                style="color: #ffe16a"
              >
                <i class="pi pi-copy"></i>
              </button>
            </h2>
            <p>
              {{ item.remarks }}
            </p>
            <!-- <p [innerHTML]="transformNewLines(item?.description || '-')"></p> -->
          </div>

          <div
            *ngIf="
              (displayMap['dummy1'] && item.dummy1) ||
              (displayMap['dummy2'] && item.dummy2) ||
              (displayMap['dummy3'] && item.dummy3) ||
              (displayMap['dummy4'] && item.dummy4) ||
              (displayMap['dummy5'] && item.dummy5) ||
              (displayMap['dummy6'] && item.dummy6) ||
              (displayMap['dummy7'] && item.dummy7) ||
              (displayMap['dummy8'] && item.dummy8) ||
              (displayMap['dummy9'] && item.dummy9) ||
              (displayMap['dummy10'] && item.dummy10) ||
              (displayMap['dummy11'] && item.dummy11) ||
              (displayMap['dummy12'] && item.dummy12) ||
              (displayMap['dummy13'] && item.dummy13) ||
              (displayMap['dummy14'] && item.dummy14)
            "
            class="section-wrapper"
            id="dummy"
          >
            <hr class="section-divider" />
            <h2 class="section-title">DUMMY</h2>
            <div class="product-details" style="margin-top: 20px">
              <div class="grid grid-cols-2 gap-2">
                <div
                  *ngIf="displayMap['dummy1'] && item.dummy1"
                  class="product-info"
                >
                  <h6>
                    DUMMY 1
                    <button
                      class="copy-btn"
                      *ngIf="item.dummy1"
                      (click)="copyToClipboard(item.dummy1)"
                      pTooltip="Copy to clipboard"
                      tooltipPosition="top"
                    >
                      <i class="pi pi-copy"></i>
                    </button>
                  </h6>

                  <p>
                    {{ item.dummy1 }}
                  </p>
                  <!-- <p [innerHTML]="transformNewLines(item.dummy1 || '-')"></p> -->
                </div>

                <div
                  *ngIf="displayMap['dummy2'] && item.dummy2"
                  class="product-info"
                >
                  <h6>
                    DUMMY 2
                    <button
                      class="copy-btn"
                      *ngIf="item.dummy2"
                      (click)="copyToClipboard(item.dummy2)"
                      pTooltip="Copy to clipboard"
                      tooltipPosition="top"
                    >
                      <i class="pi pi-copy"></i>
                    </button>
                  </h6>

                  <p>
                    {{ item.dummy2 }}
                  </p>
                  <!-- <p [innerHTML]="transformNewLines(item.dummy2 || '-')"></p> -->
                </div>
                <div
                  *ngIf="displayMap['dummy3'] && item.dummy3"
                  class="product-info"
                >
                  <h6>
                    DUMMY 3
                    <button
                      class="copy-btn"
                      *ngIf="item.dummy3"
                      (click)="copyToClipboard(item.dummy3)"
                      pTooltip="Copy to clipboard"
                      tooltipPosition="top"
                    >
                      <i class="pi pi-copy"></i>
                    </button>
                  </h6>
                  <p>
                    {{ item.dummy3 }}
                  </p>
                  <!-- <p [innerHTML]="transformNewLines(item.dummy3 || '-')"></p> -->
                </div>
                <div
                  *ngIf="displayMap['dummy4'] && item.dummy4"
                  class="product-info"
                >
                  <h6>
                    DUMMY 4
                    <button
                      class="copy-btn"
                      *ngIf="item.dummy4"
                      (click)="copyToClipboard(item.dummy4)"
                      pTooltip="Copy to clipboard"
                      tooltipPosition="top"
                    >
                      <i class="pi pi-copy"></i>
                    </button>
                  </h6>

                  <p>
                    {{ item.dummy4 }}
                  </p>
                  <!-- <p [innerHTML]="transformNewLines(item.dummy4 || '-')"></p> -->
                </div>
                <div
                  *ngIf="displayMap['dummy5'] && item.dummy5"
                  class="product-info"
                >
                  <h6>
                    DUMMY 5
                    <button
                      class="copy-btn"
                      *ngIf="item.dummy5"
                      (click)="copyToClipboard(item.dummy5)"
                      pTooltip="Copy to clipboard"
                      tooltipPosition="top"
                    >
                      <i class="pi pi-copy"></i>
                    </button>
                  </h6>
                  <p>
                    {{ item.dummy5 }}
                  </p>
                  <!-- <p [innerHTML]="transformNewLines(item.dummy5 || '-')"></p> -->
                </div>
                <div
                  *ngIf="displayMap['dummy6'] && item.dummy6"
                  class="product-info"
                >
                  <h6>
                    DUMMY 6
                    <button
                      class="copy-btn"
                      *ngIf="item.dummy6"
                      (click)="copyToClipboard(item.dummy6)"
                      pTooltip="Copy to clipboard"
                      tooltipPosition="top"
                    >
                      <i class="pi pi-copy"></i>
                    </button>
                  </h6>
                  <p>
                    {{ item.dummy6 }}
                  </p>
                  <!-- <p [innerHTML]="transformNewLines(item.dummy6 || '-')"></p> -->
                </div>
                <div
                  *ngIf="displayMap['dummy7'] && item.dummy7"
                  class="product-info"
                >
                  <h6>
                    DUMMY 7
                    <button
                      class="copy-btn"
                      *ngIf="item.dummy7"
                      (click)="copyToClipboard(item.dummy7)"
                      pTooltip="Copy to clipboard"
                      tooltipPosition="top"
                    >
                      <i class="pi pi-copy"></i>
                    </button>
                  </h6>

                  <p>
                    {{ item.dummy7 }}
                  </p>
                  <!-- <p [innerHTML]="transformNewLines(item.dummy7 || '-')"></p> -->
                </div>
                <div
                  *ngIf="displayMap['dummy8'] && item.dummy8"
                  class="product-info"
                >
                  <h6>
                    DUMMY 8
                    <button
                      class="copy-btn"
                      *ngIf="item.dummy1"
                      (click)="copyToClipboard(item.dummy1)"
                      pTooltip="Copy to clipboard"
                      tooltipPosition="top"
                    >
                      <i class="pi pi-copy"></i>
                    </button>
                  </h6>
                  <p>
                    {{ item.dummy8 }}
                  </p>
                  <!-- <p [innerHTML]="transformNewLines(item.dummy8 || '-')"></p> -->
                </div>
                <div
                  *ngIf="displayMap['dummy9'] && item.dummy9"
                  class="product-info"
                >
                  <h6>
                    DUMMY 9
                    <button
                      class="copy-btn"
                      *ngIf="item.dummy9"
                      (click)="copyToClipboard(item.dummy9)"
                      pTooltip="Copy to clipboard"
                      tooltipPosition="top"
                    >
                      <i class="pi pi-copy"></i>
                    </button>
                  </h6>
                  <p>
                    {{ item.dummy9 }}
                  </p>
                  <!-- <p [innerHTML]="transformNewLines(item.dummy9 || '-')"></p> -->
                </div>
                <div
                  *ngIf="displayMap['dummy10'] && item.dummy10"
                  class="product-info"
                >
                  <h6>
                    DUMMY 10
                    <button
                      class="copy-btn"
                      *ngIf="item.dummy10"
                      (click)="copyToClipboard(item.dummy10)"
                      pTooltip="Copy to clipboard"
                      tooltipPosition="top"
                    >
                      <i class="pi pi-copy"></i>
                    </button>
                  </h6>

                  <p>
                    {{ item.dummy10 }}
                  </p>
                  <!-- <p [innerHTML]="transformNewLines(item.dummy10 || '-')"></p> -->
                </div>
                <div
                  *ngIf="displayMap['dummy11'] && item.dummy11"
                  class="product-info"
                >
                  <h6>
                    DUMMY 11
                    <button
                      class="copy-btn"
                      *ngIf="item.dummy11"
                      (click)="copyToClipboard(item.dummy11)"
                      pTooltip="Copy to clipboard"
                      tooltipPosition="top"
                    >
                      <i class="pi pi-copy"></i>
                    </button>
                  </h6>

                  <p>
                    {{ item.dummy11 }}
                  </p>
                  <!-- <p [innerHTML]="transformNewLines(item.dummy11 || '-')"></p> -->
                </div>
                <div
                  *ngIf="displayMap['dummy12'] && item.dummy12"
                  class="product-info"
                >
                  <h6>
                    DUMMY 12
                    <button
                      class="copy-btn"
                      *ngIf="item.dummy12"
                      (click)="copyToClipboard(item.dummy12)"
                      pTooltip="Copy to clipboard"
                      tooltipPosition="top"
                    >
                      <i class="pi pi-copy"></i>
                    </button>
                  </h6>
                  <p>
                    {{ item.dummy12 }}
                  </p>
                  <!-- <p [innerHTML]="transformNewLines(item.dummy12 || '-')"></p> -->
                </div>
                <div
                  *ngIf="displayMap['dummy13'] && item.dummy13"
                  class="product-info"
                >
                  <h6>
                    DUMMY 13
                    <button
                      class="copy-btn"
                      *ngIf="item.dummy13"
                      (click)="copyToClipboard(item.dummy13)"
                      pTooltip="Copy to clipboard"
                      tooltipPosition="top"
                    >
                      <i class="pi pi-copy"></i>
                    </button>
                  </h6>
                  <p>
                    {{ item.dummy13 }}
                  </p>
                  <!-- <p [innerHTML]="transformNewLines(item.dummy13 || '-')"></p> -->
                </div>
                <div
                  *ngIf="displayMap['dummy14'] && item.dummy14"
                  class="product-info"
                >
                  <h6>
                    DUMMY 14
                    <button
                      class="copy-btn"
                      *ngIf="item.dummy14"
                      (click)="copyToClipboard(item.dummy14)"
                      pTooltip="Copy to clipboard"
                      tooltipPosition="top"
                    >
                      <i class="pi pi-copy"></i>
                    </button>
                  </h6>
                  <p>
                    {{ item.dummy14 }}
                  </p>
                  <!-- <p [innerHTML]="transformNewLines(item.dummy14 || '-')"></p> -->
                </div>
              </div>
            </div>

            <button class="view-more"></button>
          </div>
        </div>
      </section>
      <button class="read-more-btn" (click)="toggleCard(i)">
        {{ expandedCards[i] ? "Read Less" : "Read More" }}
      </button>
    </div>

    <!-- Sidebar -->
    <aside class="sidebar" *ngIf="i == 0">
      <div
        style="
          display: flex;
          width: 100%;
          align-items: center;
          justify-content: space-between;
        "
      >
        <!-- Left side: Total Records -->
        <div style="width: 50%">
          <strong
            style="
              background: linear-gradient(145.5deg, #388e3c, #235e5e 99.58%);
              color: #ffed8d;
              font-size: 16px;
              font-weight: 700;
              padding: 11px 15px;
              border-radius: 12px;
              box-shadow: 0 2px 4px #0003;
              white-space: nowrap;
              display: block;
              width: fit-content;
            "
          >
            Total Records: {{ totalRecords }}
          </strong>
        </div>

        <!-- Right side: Buttons -->
        <div
          style="
            width: 50%;
            display: flex;
            justify-content: flex-end;
            margin-left: 50px;
          "
        >
          <button
            style="
              background-color: #ffcd04;
              padding: 8px;
              border: none;
              border-radius: 6px;
              cursor: pointer;
              margin-right: 10px;
            "
            (click)="exportExcel('csv')"
          >
            <img src="../../../../assets/icons/download.png" />
            <span style="font-size: 12px; color: #000">CSV</span>
          </button>
          <button
            style="
              background-color: #ffcd04;
              padding: 8px;
              border: none;
              border-radius: 6px;
              cursor: pointer;
            "
            (click)="exportExcel('xlsx')"
          >
            <img src="../../../../assets/icons/download.png" />
            <span style="font-size: 12px; color: #000">XLS</span>
          </button>
        </div>
      </div>

      <h3 class="sidebar-title">
        Filters
        <button class="sidebar-toggle" (click)="toggleSidebar()">
          <span *ngIf="!isSidebarOpen">☰</span>
          <span *ngIf="isSidebarOpen">×</span>
        </button>
      </h3>

      <ul [class.active]="isSidebarOpen">
        <li>
          <label for="categoryFilter">ROUTE TYPE</label>
          <p-dropdown
            [options]="PlatformFliters.routeType"
            [filter]="true"
            filterPlaceholder="Search Route Type"
            class="w-full custom-dropdown"
            [(ngModel)]="currentFliter.routeType"
            (onChange)="createFilter('routeType', $event.value)"
            placeholder="Select Route Type"
          ></p-dropdown>
        </li>
        <li>
          <label for="categoryFilter">COMPANY</label>
          <p-dropdown
            [options]="PlatformFliters.companyName"
            [filter]="true"
            filterPlaceholder="Search Company Name"
            class="w-full custom-dropdown"
            [(ngModel)]="currentFliter.companyName"
            (onChange)="createFilter('companyName', $event.value)"
            placeholder="Select Company Name"
          ></p-dropdown>
        </li>
        <li>
          <label for="categoryFilter">AI/KSM</label>
          <p-dropdown
            [options]="PlatformFliters.typesOfRoute"
            [filter]="true"
            filterPlaceholder="Search AI/KSM"
            class="w-full custom-dropdown"
            [(ngModel)]="currentFliter.typesOfRoute"
            (onChange)="createFilter('typesOfRoute', $event.value)"
            placeholder="Select AI/KSM"
          ></p-dropdown>
        </li>
        <li>
          <label for="categoryFilter">APPLICATION OF INTER</label>
          <p-dropdown
            [options]="PlatformFliters.activeIngredient"
            [filter]="true"
            filterPlaceholder="Search Application Of Inter"
            class="w-full custom-dropdown"
            [(ngModel)]="currentFliter.activeIngredient"
            (onChange)="createFilter('activeIngredient', $event.value)"
            placeholder="Select Application Of Inter"
          ></p-dropdown>
        </li>

        <li>
          <label for="categoryFilter">FEILD OF APPLICATION</label>
          <p-dropdown
            [options]="PlatformFliters.fieldOfApplication"
            [filter]="true"
            filterPlaceholder="Search Feild Of Application"
            class="w-full custom-dropdown"
            [(ngModel)]="currentFliter.fieldOfApplication"
            (onChange)="createFilter('fieldOfApplication', $event.value)"
            placeholder="Select Feild Of Application"
          ></p-dropdown>
        </li>

        <li>
          <label for="colorFilter">ORDER</label>

          <p-dropdown
            [options]="sortByOptions"
            [filter]="true"
            filterPlaceholder="Search Order"
            filterBy="name"
            class="w-full custom-dropdown"
            [(ngModel)]="sortBy"
            (onChange)="applyFilter()"
            optionLabel="name"
            optionValue="code"
            placeholder="Select Order"
          >
          </p-dropdown>
        </li>
        <li>
          <label for="categoryFilter">UPDATION DATE</label>
          <p-dropdown
            [options]="PlatformFliters.updationDate"
            [filter]="true"
            filterPlaceholder="Search Updation Date"
            class="w-full custom-dropdown"
            [(ngModel)]="currentFliter.updationDate"
            (onChange)="createFilter('updationDate', $event.value)"
            placeholder="Select Updation Date"
          ></p-dropdown>
        </li>
      </ul>
      <div class="filter-buttons">
        <button (click)="applyFilter()">Apply Filter</button>
        <button (click)="resetFilter()">Reset Filter</button>
      </div>
    </aside>
  </div>

  <div class="pagination-container">
    <p-paginator
      (onPageChange)="onPageChange($event)"
      [first]="first"
      [rows]="rows"
      [totalRecords]="totalRecords"
      [styleClass]="'custom-paginator'"
    >
    </p-paginator>

    <p class="total-pages" *ngIf="totalpages > 2">
      Total Pages: <span>{{ totalpages }}</span>
    </p>
  </div>
  <button class="back_to_top my-5" (click)="scrollToTop()">
    <img
      class="back_to_top_img"
      src="../../../assets/icons/output-onlinepngtools (5).png"
    />
  </button>
</div>
<ng-template #noResultsFound>
  <div class="no-results-container" *ngIf="searched">
    <img
      src="../../../assets/img/no-data.png"
      class="no-results-image"
      alt="No data available"
    />
    <div class="no-results-message color_black">
      <span class="font_20 weight_800"
        >Sorry – The search found zero results. Why…</span
      >
      <ul class="no-results-list text_start">
        <li>
          <span class="font_20 weight_500"
            >Make sure you have selected the correct search criteria</span
          >
        </li>
        <li>
          <span class="font_20 weight_500"
            >Make sure that all words are spelled correctly</span
          >
        </li>
        <li>
          <span class="font_20 weight_500">Try different keywords</span>
        </li>
        <li>
          <span class="font_20 weight_500">Try more general keywords</span>
        </li>
      </ul>
    </div>
    <!-- Back to search button -->
    <button class="btn-back-to-search" (click)="goBackToSearch()">
      Back to Search
    </button>
  </div>
</ng-template>
